import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    rootBar: {
      marginTop: 32,
    },

    bar: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,

      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },

      '& .MuiTabs-root': { minHeight: 35 },

      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },
    },

    tab: {
      transition: 'background 250ms linear',
      minHeight: 35,
      minWidth: 130,

      '&:hover': {
        textDecoration: 'none',
      },

      '&:disabled': {
        opacity: 0.7,
      },

      '& .MuiTab-wrapper': {
        fontSize: 14,
        color: palette.gray,
      },

      '&.Mui-selected': {
        fontWeight: typography.fontWeightMedium,
        backgroundColor: 'rgba(239, 205, 51, .15)',
      },
    },
  });
